module.exports = __webpack_public_path__ + "img/notifications/safari-notifications-blocked-12f4cd246fb3918efa97b7d2ca5b792a.png";